import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class HttpService {
    backendEndpoint = '';

    constructor(private http: HttpClient) { }

    getRecords<T>(url: string, filter?: any, responseType: any = 'json', headers?: any) {
        let params = filter;

        // Convert object to HttpParams to preserve empty string parameters.
        // Coerce null/undefined to '' so they don't serialize as "null"/"undefined" in URL.
        if (filter && typeof filter === 'object' && !(filter instanceof HttpParams)) {
            const sanitized: Record<string, string> = {};
            for (const key of Object.keys(filter)) {
                const v = filter[key];
                sanitized[key] = v === null || v === undefined ? '' : String(v);
            }
            params = new HttpParams({ fromObject: sanitized });
        }

        return this.http.get<T>(`${this.backendEndpoint}${url}`, {
            params: params,
            responseType: responseType,
            headers: headers
        });
    }

    getRecord<T>(url: string, id: string) {
        return this.http.get<T>(`${this.backendEndpoint}${url}/${id}`);
    }

    saveRecord<T>(url: string, paylod: any) {
        return this.http.post<T>(`${this.backendEndpoint}${url}`, paylod);
    }

    deleteRecord<T>(url: string, id: string, payload?: any) {
        return this.http.delete<T>(`${this.backendEndpoint}${url}/${id}`, payload);
    }

    updateRecord<T>(url: string, id: string, paylod: any) {
        return this.http.put<T>(`${this.backendEndpoint}${url}/${id}`, paylod);
    }

    updateStatus<T>(url: string, id: string, status: any) {
        return this.http.put<T>(`${this.backendEndpoint}${url}/${id}`, null, {
            params: status
        });
    }

    updateRecordPartially<T>(url: string, id: string, paylod: any) {
        return this.http.patch<T>(`${this.backendEndpoint}${url}/${id}`, paylod);
    }

    updateRecordWithoutID<T>(url: string, payload: any) {
        return this.http.patch<T>(`${this.backendEndpoint}${url}`, payload);
    }

    patchRecordWOIdAndWithParams<T>(url: string, payload: any, filter: any) {
        return this.http.patch<T>(`${this.backendEndpoint}${url}`, payload, {
            params: filter
        });
    }

    addUpdateDocument<T>(url: any, file: File) {
        return this.http.put<T>(`${this.backendEndpoint}${url}`, file);
    }

    uploadRecordWithoutId<T>(url: string, file: any) {
        return this.http.put<T>(`${this.backendEndpoint}${url}`, file);
    }
}
